import React from "react";
import PropTypes from "prop-types";
import withStyles from "isomorphic-style-loader/lib/withStyles";

import s from "./Auth.scss";

import Layout from "../../../../components/Layout";
import FooterConsole from "../../../../components/FooterConsole/FooterConsole";

function Auth({ children }) {
  return (
    <Layout layoutType="empty">
      <div className="Auth">
        <div className="Auth__header">
          <img
            className="Auth__logo"
            src="/images/henkel-logo.svg"
            alt="Henkel Beauty Care"
          />
          <div className="Auth__companyName">Henkel Beauty Care</div>
        </div>

        <div className="Auth__art" />

        <div className="Auth__content">
          <div className="Auth__body">{children}</div>
          <FooterConsole auth />
        </div>
      </div>
    </Layout>
  );
}

Auth.propTypes = {
  children: PropTypes.element.isRequired
};

export default withStyles(s)(Auth);



// WEBPACK FOOTER //
// ./src/routes/client/site/auth/Auth.js